"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _modalActions = require("../../redux/actions/modalActions");
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _ExchangeNavModalComponent = _interopRequireDefault(require("./ExchangeNavModalComponent"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var _onGoToSettings = function onGoToSettings(props) {
  // Close modal and navigate to settings
  if (props.close) props.close();
  if (props.history) props.history.push('/settings/trade');
};
var ModalWithRouter = (0, _reactRouterDom.withRouter)(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_ExchangeNavModalComponent["default"], _extends({}, props, {
    onGoToSettings: function onGoToSettings() {
      return _onGoToSettings(props);
    },
    onClose: props.close
  }));
});
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.EXCHANGE_NAV_WARNING
})(ModalWithRouter);